import React, { useContext } from 'react';
import { StyleSheet } from 'react-native';
import AppContext, { AppActions, AppEvents } from '../../contexts/App';
import { Icon } from '@rneui/themed';

const NavSearchIcon = () => {
    const { state, dispatch } = useContext(AppContext);

    const onSearchPress = () => {
        let searchState = AppEvents.SEARCH_DIALOGUE_STATE_CLOSED;

        if (state?.search?.state?.equals(AppEvents.SEARCH_DIALOGUE_STATE_CLOSED)) {
            searchState = AppEvents.SEARCH_DIALOGUE_STATE_OPEN;
        }

        dispatch({
            state: searchState,
            type: AppActions.SEARCH_STATE_CHANGE
        });
    };

    if (!state?.search?.state) {
        return null;
    }

    const isOpen = state.search.state === AppEvents.SEARCH_DIALOGUE_STATE_OPEN;

    return (
        <Icon
            color='#153d6e'
            containerStyle={{ borderLeftColor: '#dde4e9', borderLeftWidth: StyleSheet.hairlineWidth, paddingLeft: 5 }}
            name={isOpen ? 'times' : 'search'}
            onPress={onSearchPress}
            size={16}
            style={{ paddingHorizontal: 10 }}
            type='font-awesome-5'
        />
    );
};

export default NavSearchIcon;
